import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';

import useLeasingContacts from '../useLeasingContacts';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    updateInProcess,
    handleCreateOrUpdate,
    contactRoles,
    managers,
    filters,
    singleItem,
  } = useLeasingContacts(false);

  console.log('contactRoles=', filters);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const title = isNew
    ? t('CREARE CONTATTO COMMERCIALE')
    : t('MODIFICA ELENCO CONTATTI COMMERCIALI');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          scrollToFirstError
          initialValues={{
            name: '',
            surname: '',
            company_title: '',
            contact_rank: '',
            email: '',
            cellphone: '',
            phone: '',
            tax_code: '',
            first_visit_date: '',
            company_address: '',
            status: 'active',
            visit_quantity: '',
            rooms_proposet: '',
            lasttime_contact_date: '',
            last_visit_link: '',
            leasings_contact_role_id: '',
            leasings_manager_id: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection
            singleItem={singleItem}
            contactRoles={contactRoles}
            managers={managers}
            isNew={isNew}
          />
          <Row gutter={16}>
            <Col>
              <Button
                htmlType='submit'
                width={'150px'}
                big
                icon={<CheckOutlined />}
                loading={updateInProcess}
              >
                {t('Invia')}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default Edit;
